import { IconButton } from 'react-native-paper';
import { useAppTheme } from '../theme';
import { Platform } from 'react-native';
import { useAppSelector } from '../redux/hooks';
import MapView from 'react-native-maps';

interface Props {
  webMap?: google.maps.Map | null;
  mapRef?: React.RefObject<MapView>;
}

export default function CurrentLocationButton({ webMap, mapRef }: Props) {
  const theme = useAppTheme();
  const { usersLocation } = useAppSelector((state) => state.user);
  const { mobileMapWindow } = useAppSelector((state) => state.map);

  function buttonPressed() {
    if (Platform.OS !== 'web') {
      mapRef?.current?.animateToRegion(
        {
          latitude: usersLocation.latitude,
          longitude: usersLocation.longitude,
          latitudeDelta: mobileMapWindow.latitudeDelta,
          longitudeDelta: mobileMapWindow.longitudeDelta,
        },
        500
      );
    } else {
      webMap?.panTo({
        lat: usersLocation.latitude,
        lng: usersLocation.longitude,
      });
    }
  }

  return (
    <IconButton
      icon="crosshairs-gps"
      size={30}
      style={{
        backgroundColor: 'transparent',
      }}
      iconColor={theme.colors.onBackground}
      onPress={buttonPressed}
    />
  );
}
